import React from 'react'
import { Router, Route, Redirect } from 'react-router-dom'
import { history } from './store'
import store from './store'
import Main from './containers/main.container'
import Main_employer from './containers/employer/main.container'
import { logout } from './actions'
import { logout as logout_employer } from './actions/employer'
import IdleTimer from 'react-idle-timer'
import { useSelector } from 'react-redux'
import { employerSide } from './routerHistory'

export default class RouteComponent extends React.Component {
  constructor(props) {
    super(props)
    this.idleTimer = null
    this.handleOnIdle = this.handleOnIdle.bind(this)
  }

  render() {
    return (
      <div>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref
          }}
          timeout={1000 * 60 * 60}
          onIdle={this.handleOnIdle}
          debounce={250}
        />

        <Router history={history}>
          <Route path="/*">
            {employerSide ? <Main_employer /> : <Main />}
            {/** routes moved to main.component.js */}
          </Route>
        </Router>
      </div>
    )
  }

  handleOnIdle() {
    if (employerSide) {
      store.dispatch(logout_employer())
    } else {
      store.dispatch(logout())
    }
  }
}

export const PrivateRoute = ({ children, ...rest }) => {
  const isAuthed = useSelector((state) => {
    const client = state.client
    return state.oidc.user ? state.oidc.user !== null : client.user !== null
  })

  return isAuthed ? (
    <Route {...rest}>{children}</Route>
  ) : (
    <Redirect to="/dashboard/login" />
  )
}
